<template>
  <div class="InspectRoomArea">
    <!-- 导航栏 -->
    <Header showCreate @create="_create" @back="$router.go(-1)" />

    <div class="content">
      <div class="content-title">{{ stringList.InspectionArea }}</div>
      <div class="list">
        <AreaItem
          :roomNumber="dataForm.roomNumber"
          v-for="(item, index) in areaListAll"
          :key="index"
          :item="item"
        />
      </div>

      <div class="comments">
        <div class="addBtn row" v-if="!showNote" @click="showNote = true">
          <svg-icon
            iconClass="add2"
            style="width: 15px; height: 15px"
          ></svg-icon>
          <span>{{ stringList.AddComments }}</span>
        </div>
        <div v-else>
          <div class="title">{{ stringList.OverallComments }}</div>
          <div class="comments-textarea">
            <a-textarea
              v-model="note"
              :placeholder="stringList.EnterCommentsCharacters"
              :maxlength="200"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <van-button
        :spinning="true"
        class="button"
        @click="handleSubmit"
        native-type="submit"
        >{{ stringList.submit }}</van-button
      >
    </div>

    <!-- <Copyright /> -->

    <ResultModal ref="resultModalRef" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import ResultModal from "@/views/InspectRoom/components/ResultModal.vue";
// import Copyright from "@/components/Copyright.vue";
import AreaItem from "./components/AreaItem.vue";
import { postAction } from "@/api/manage";
import { mapGetters } from "vuex";
import { Toast } from "vant";

export default {
  name: "InspectRoomArea",
  components: {
    // Copyright,
    AreaItem,
    Header,
    ResultModal,
  },
  data() {
    return {
      dataForm: {},
      areaListAll: [],
      showNote: false,
      note: "", // 备注
    };
  },
  computed: {
    ...mapGetters({
      stringList: "stringList",
      userInfo: "userInfo",
      language: "language",
    }),
  },
  activated() {
    const { areaId, inspectionItemResponseList } =
      this.$store.state.router.questionBackData;
    if (areaId) {
      // questions 返回
      let index = this.areaListAll.findIndex((item) => {
        return item.areaId == areaId;
      });
      this.$set(
        this.areaListAll[index],
        "inspectionItemResponseList",
        inspectionItemResponseList
      );
      this.$set(
        this.areaListAll[index],
        "wrongInspection",
        inspectionItemResponseList.filter((item) => item.isWrong).length
      );

      this.$store.commit("SET_QUESTION_BACK_DATA", {});
    }
    if (["/InspectRoom"].includes(this.$store.state.router.routeFromPath)) {
      // 重置表单
      const { dataForm } = this.$route.query;
      this.dataForm = JSON.parse(dataForm);
      this.areaListAll = [];
      this.showNote = false;
      this.note = "";
      this.getAllArea();
    }
  },
  created() {
    const { dataForm } = this.$route.query;
    this.dataForm = JSON.parse(dataForm);

    this.getAllArea();
  },
  methods: {
    _create() {
      this.$router.push({
        path: "/NewTicket",
        query: { roomNumber: this.dataForm.roomNumber },
      });
    },
    async getAllArea() {
      const { data } = await postAction(
        "/adminApi/htInspection/getAreaItemListAll",
        {
          hotelId: this.userInfo.hotelId,
        }
      );
      this.areaListAll = data.map((item) => {
        return {
          ...item,
          wrongInspection: null,
          inspectionItemResponseList: item.inspectionItemResponseList.map(
            (item) => {
              return {
                ...item,
                isWrong: false,
                errorType: "",
                img: [],
                notes: "",
              };
            }
          ),
        };
      });
    },

    async handleSubmit() {
      let failItemParamList = [];
      this.areaListAll.forEach((item, index) => {
        let areaName2 = JSON.parse(item.areaName2);
        if (item.wrongInspection == null) {
          this.$set(this.areaListAll[index], "wrongInspection", 0);
        }
        if (item.wrongInspection > 0) {
          item.inspectionItemResponseList.forEach((inspectionItem) => {
            let itemName2 = JSON.parse(inspectionItem.itemName2);
            if (inspectionItem.isWrong) {
              console.log("inspectionItem", inspectionItem);
              failItemParamList.push({
                areaId: item.areaId,
                areaName: item.areaName,
                areaNameLanguage: areaName2[this.language],
                itemId: inspectionItem.itemId,
                itemName: inspectionItem.itemName,
                itemNameLanguage: itemName2[this.language],
                img: inspectionItem.img.map((item) => item.url).join(","),
                notes: inspectionItem.notes,
              });
            }
          });
        }
      });
      const { cleanerId, cleanerName, roomNumber, startCheckTime, vacant } =
        this.dataForm;

      let params = {
        hotelId: this.userInfo.hotelId,
        hotelDeptId: this.userInfo.hotelDeptId,
        roomNumber,
        cleanerId,
        cleanerName,
        vacant: true,
        startCheckTime,
        endCheckTime: new Date(),
        note: this.note,
        failItemParamList,
      };

      Toast.loading({
        message: this.stringList.Loading,
        forbidClick: true,
        duration: 0,
      });

      try {
        const { status, msg, data } = await postAction(
          `/api/common/hotel/data/roomInspectionOrder/create`,
          params
        );
        if (status != 0) {
          Toast.fail(msg);
          return;
        }
        Toast.clear();
        // this.$router.replace({
        //   name: "InspectResult",
        //   query: {
        //     resultData: encodeURIComponent(JSON.stringify(data)),
        //     failItemParamList: encodeURIComponent(
        //       JSON.stringify(failItemParamList)
        //     ),
        //   },
        // });
        this.$refs.resultModalRef.init({
          resultData: data,
          failItemParamList,
        });
      } catch (error) {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.InspectRoomArea {
  height: 100%;
  width: 100%;
  // flex: 1;
  background-color: #f2f2f2;
  overflow-y: auto;
}

.content {
  min-height: 374px;
  padding: 24px 1.75rem;
  opacity: 1;
  background: #ffffff;
  position: relative;
  z-index: 10;

  .content-title {
    height: 26px;
    opacity: 1;
    font-family: Arial;
    font-size: 22px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    color: #5a578c;
    margin-bottom: 32px;
  }

  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap; /* 允许多行 */
    margin-top: 24px;
  }
}

.comments {
  .addBtn {
    span {
      font-family: Arial;
      font-size: 16px;
      color: #101010;
      margin-left: 9px;
    }
  }

  .title {
    font-family: Arial;
    font-size: 16px;
    color: #101010;
    line-height: 46px;
    text-align: left;
  }

  &-textarea {
    /deep/.ant-input {
      border: 1px solid #afafaf;
      border-radius: 6px !important;
      background: #f2f2f2 !important;
    }
  }
}

.footer {
  position: relative;
  z-index: 10;
  margin: 24px auto 32px;
  .button {
    width: 200px;
    height: 48px;
    border-radius: 8px;
    opacity: 1;
    background: #ff6600;
    font-family: Arial;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.72px;
    text-align: center;
    // display: flex;
    // align-items: center;
    letter-spacing: 0em;
    color: #ffffff;
    border: 0;
  }
}
</style>
